module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_arrow_02-5bd6530cda05a0974be758150238a8e1.svg";